module.exports = __webpack_public_path__ + "img/9788980402311.a28419b3.jpg";